import { Paper, TextField, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

const disabledInputSx = {
    "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: "#010a1a",
    },
};

export const ProductHotelNoteControl = (props) => {
    const { control, fieldName, readOnly = false } = props;
    const { t } = useTranslation();

    return (
        <Paper
            sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                margin: "1rem",
                padding: "1rem",
                gap: 2,
            }}
        >
            <Typography sx={{ minWidth: "100px" }}>
                {t("products.ProductConfigurationDialog.productHotelNote")}
            </Typography>
            <Controller
                name={fieldName}
                control={control}
                render={({ field }) => (
                    <TextField
                        {...field}
                        id="note"
                        type="text"
                        fullWidth
                        multiline
                        rows={3}
                        disabled={readOnly}
                        sx={readOnly ? disabledInputSx : { minWidth: "70%" }}
                    />
                )}
            />
        </Paper>
    );
};
